var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "log-in",
    width: 22.05,
    height: 22.05,
    viewBox: "0 0 22.05 22.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#1f3f93}\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    d: "M20.693.014C20.67.012 20.651 0 20.627 0h-9.872A2.759 2.759 0 0 0 8 2.756v.919a.918.918 0 1 0 1.837 0v-.919a.92.92 0 0 1 .918-.919h4.279l-.28.094a1.847 1.847 0 0 0-1.244 1.744v13.781h-2.755a.92.92 0 0 1-.918-.919V14.7A.918.918 0 1 0 8 14.7v1.837a2.759 2.759 0 0 0 2.755 2.756h2.755v.919a1.839 1.839 0 0 0 1.837 1.838 1.93 1.93 0 0 0 .585-.091l5.517-1.84a1.847 1.847 0 0 0 1.244-1.744V1.837a1.84 1.84 0 0 0-2-1.824z",
    className: "cls-1",
    transform: "translate(-.644)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    d: "M9.833 8.942L6.159 5.269a.918.918 0 0 0-1.568.649v2.755H.918a.918.918 0 0 0 0 1.837h3.674v2.755a.918.918 0 0 0 1.568.649l3.673-3.673a.917.917 0 0 0 0-1.299z",
    className: "cls-1",
    transform: "translate(0 -.405)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.ec8b5d7b05075bff8c97d31b50d99019.svg";
export { ForwardRef as ReactComponent };